import { Link } from 'react-router';

export function ExamplesIndexPage() {
  return (
    <>
      <h2>examples</h2>

      <div className="card">
        <h3>What</h3>
        <p style={{ marginTop: 0 }}>
          mbtiler API 를 OpenLayers / MapLibre GL 두 클라이언트 라이브러리에서 호출해
          지도 위에 mbtiles 를 띄우는 살아있는 예제입니다.
        </p>
        <h3 style={{ marginTop: '1rem' }}>Why</h3>
        <p style={{ marginBottom: 0 }}>
          외부 앱이 mbtiler 를 어떻게 통합하는지 보고 그대로 복사할 수 있는 레퍼런스이자,
          권한 게이트(public / read-token) 가 의도대로 동작하는지 직접 토글해 검증하는
          용도입니다.
        </p>
      </div>

      <div className="row" style={{ alignItems: 'stretch' }}>
        <Link
          to="/examples/openlayers"
          className="card"
          style={{ textDecoration: 'none', flex: 1, minWidth: 280 }}
          data-testid="examples-link-ol"
        >
          <h3>OpenLayers</h3>
          <div style={{ fontSize: '0.9rem', color: '#6b7280' }}>
            ol@10 — XYZ raster 또는 MVT vector 자동 분기.
          </div>
        </Link>
        <Link
          to="/examples/maplibre"
          className="card"
          style={{ textDecoration: 'none', flex: 1, minWidth: 280 }}
          data-testid="examples-link-ml"
        >
          <h3>MapLibre GL</h3>
          <div style={{ fontSize: '0.9rem', color: '#6b7280' }}>
            maplibre-gl — TileJSON 을 그대로 raster/vector source 로 등록.
          </div>
        </Link>
      </div>
    </>
  );
}
